export { default } from '@esentai/core/features/productView/api';
